/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React from 'react'
import { ShimmerBadge } from 'react-shimmer-effects'

function SidePanelSkeleton() {
    return (
        <div className="xl:block hidden min-w-[20%] max-w-[20%] bg-[#FFFFFF] pb-[100px] border-r border-[#A5A5A5] fixed h-screen sidebar overflow-auto top-[169px]">
            <ul>
                <>{[...Array(10)].map((whishlist,i)=>(
                    <motion.li
                        key={i} 
                        className='bg-[#F5F5FA] border-l-[3px]'>
                        <div className="pl-10 pr-3 flex justify-between items-center">
                            <span className="text-xs6 font-semibold text-[#090406]" 
                            ><ShimmerBadge width={200} />
                            </span>
                        </div>
                        <br/>
                    </motion.li>
                )
                )}</>
                
            </ul>
        </div>
    )
}

export default SidePanelSkeleton